import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Form, FormGroup, Checkbox, Row, Col,ControlLabel, FormControl, Button} from 'react-bootstrap';
import {prepareSelectOptionsList,filterFocusAreaOptions, removePrefix,filterFocusAreaSelectedOptions} from 'util/Utils';
import formatNumbers  from 'util/formatNumbers';
import Select   from 'react-select'
import {
    makeRequest,   reorderImages,  updateRecord, displayMessage,} from  'actions';
import {  FETCH_ADMIN_PRODUCT, FETCH_FOCUS_AREAS,UPDATE_ADMIN_PRODUCT, FETCH_ALL_SELLERS_LIST} from "actions/actionTypes";


import AdminProductImageEdit from 'dashboard/products/AdminProductImageEdit.js';
import ReactDOM from 'react-dom';
import {getProduct} from 'reducers/reducer_admin_products';


import config from  '../../../config';
import { getAllowedAgeGroups, removeInvalidAgeGroups } from '../../shared/sharedMethods';

class AdminProductEdit extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        // var selectedFocusAreas = _.isUndefined(this.props.product) ? [] : _.map(this.props.product.ProductTags, function (tag) {
        //     return {'value': tag, 'label': tag};
        // })
        //  var ageGroupMap = _.isUndefined(this.props.product) ? [] : this.props.product.ProductAgeRange

        const { featureFlags } = this.props.location.state
        const { EnableEditShopifyListingPrice = false } = featureFlags || {}

        this.state = {
            //      focusAreasOptionsList: filterFocusAreaOptions(this.props.focusAreas.data, ageGroupMap),
            newRecord: this.props.location.pathname.includes('/seller/add') ? true : false,
            isShopifyListingPriceEnabled: EnableEditShopifyListingPrice,
            currentRecord:{},
            //   productSeller: _.isUndefined(this.props.product) ? '' : this.props.product['SellerID'][0]._id,
            //     ProductTags:filterFocusAreaSelectedOptions(this.props.focusAreas.data, ageGroupMap,selectedFocusAreas),
            //  ProductAgeRange: ageGroupMap
        }
        this.originalProductData  = {}
        this.allSellersOptionsList = prepareSelectOptionsList(this.props.allSellersList.data, {
            label: 'DisplayName',
            value: '_id'
        })
        this.allSellersOptionsList.unshift({label: 'All', value: 'all'});

        this.addRecord = this.addRecord.bind(this);
        this.editRecord = this.editRecord.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })
        }
        //  if (_.size(nextProps.focusAreas.data) !== _.size(this.props.focusAreas.data)) {
        //     var selectedFocusAreas = _.isUndefined(this.props.product) ? [] : _.map(this.props.product.ProductTags, function (tag) {
        //         return {'value': tag, 'label': tag};
        //     })
        //      this.setState({
        //          focusAreasOptionsList: filterFocusAreaOptions(nextProps.focusAreas.data, this.state.ProductAgeRange),
        //          ProductTags: filterFocusAreaSelectedOptions(nextProps.focusAreas.data, this.state.ProductAgeRange,selectedFocusAreas)  })
        // }
    }

    componentWillMount() {
        var self = this;

        var methodData = {
            "success_event": FETCH_ADMIN_PRODUCT,
            'endpoint': '/products/' + encodeURIComponent(this.props.params.product_id),
            'not_display_success_message': true,
        };
        this.props.makeRequest({}, methodData).then(res => {
            self.originalProductData = res.data
            var SellerProcessCost ={}

            const productAgeRange = removeInvalidAgeGroups(res.data.ProductAgeRange).map(tag =>  ({value: tag, label: tag}))

            if ( _.get(res.data, 'CustomData.SellerProcessCost')) {
                var foundOption = _.find(_.get(res.data.SellerID,'PartnerData.ProcessCostOptions',[]),item=> {
                    return item.Slug == _.get(res.data, 'CustomData.SellerProcessCost')
                })
                SellerProcessCost =foundOption? {value:foundOption.Slug,label:foundOption.Label}:{}
            }
                        self.setState({
                            currentRecord: {
                                ..._.pick(res.data, ['_id', 'ProductName', 'OriginalUrl', 'Description', 'OriginalDescription',   'Markets', 'Condition', 'Status',  'Payout', 'OriginalPrice', 'Price', 'ShopifyListingPrice']),
                                SellerID: res.data.SellerID._id,
                                ProductTags: _.map(res.data.ProductTags, function (tag) {
                                    return {value: tag, label: tag};
                                }),
                                SellerProcessCost:SellerProcessCost,
                                ProductProcessCost:_.get(res.data,'CustomData.ProductProcessCost',''),
                                displayOverrideProcessingCost:_.get(res.data,'CustomData.ProductProcessCost','')?true:false,
                    ProductAgeRange: productAgeRange,
                }

            })
        })

        // if (_.size(this.props.focusAreas.data) == 0) {
        //     var methodData = {
        //         "success_event": FETCH_FOCUS_AREAS,
        //         "endpoint": "/focus-areas",
        //         'not_display_success_message': true
        //     };
        //     this.props.makeRequest({}, methodData).catch(err => {
        //     });
        // }
        if (_.size(this.props.allSellersList.data) == 0) {
            var methodData = {
                "success_event": FETCH_ALL_SELLERS_LIST,
                "endpoint": "/sellers",
                'not_display_success_message': true
            };
            this.props.makeRequest({sortBy:'DisplayName:1',all:true, include:['DisplayName','InventoryOwnership']}, methodData).catch(err => {
            });
        }
    }


    onAgeRangeChange(options) {
        this.setState({
            //   focusAreasOptionsList:  filterFocusAreaOptions(this.props.focusAreas.data, _.map(options, 'value')),
            //    ProductTags:filterFocusAreaSelectedOptions(this.props.focusAreas.data, _.map(options, 'value') ,this.state.ProductTags),
            'ProductAgeRange': _.map(options, 'value')});
    }

    addRecord(e) {
        e.preventDefault();
    }

    editRecord(e) {
        e.preventDefault();
        const self = this;
        var objectData = this.getFormData();
        if (!objectData) {
            return
        }
        var methodData = {
            success_event: UPDATE_ADMIN_PRODUCT,
            type: 'patch',
            endpoint: '/products/' + encodeURIComponent(this.originalProductData._id),
            messageData: {'#1#': 'Product'},
            messageCode: 'recordUpdated'
        }
        this.props.makeRequest(objectData, methodData).then(function (response) {
            console.log('response.data.ShopifyListingPrice', response.data.ShopifyListingPrice  );
            self.setState({
                currentRecord: {
                    ...self.state.currentRecord,
                    ShopifyListingPrice:response.data.ShopifyListingPrice
                }});
        });
    }

    getFormData() {

        var formData = _.pick(this.state.currentRecord, ['_id', 'ProductName', 'OriginalUrl', 'Description', 'OriginalDescription',   'Markets', 'Condition', 'Status',   'Payout', 'OriginalPrice', 'Price', 'ShopifyListingPrice']);
        var self = this,dataNotValid = false;
        if (this.state.currentRecord.SellerID !== self.originalProductData.SellerID._id) {
            formData['SellerIDToSave'] = this.state.currentRecord.SellerID
        }
        formData['ProductAgeRange'] =  _.map(_.get(this.state.currentRecord,  'ProductAgeRange', []), 'value')
        formData['ProductTags'] =  _.map(_.get(this.state.currentRecord,  'ProductTags', []), 'value')

        _.forEach(['ProductName', 'OriginalPrice', 'Price', 'Condition'], function (requiredField) {
            if (formData[requiredField] == '') {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': _.startCase(requiredField) + ' field is required',
                });
                dataNotValid = true;
                return false;
            }
        }.bind(this))
        formData['Payout'] = parseInt(formData['Payout']);
        formData['CustomDataToUpdate'] = {}

        if( _.get(this.state.currentRecord, 'ProductProcessCost','') !=='' ){
            formData['CustomData'] = _.extend(formData['CustomDataToUpdate'], {
                ProductProcessCost: _.get(this.state.currentRecord, 'ProductProcessCost'),
                SellerProcessCost:'unset'
            })
        }else  if( _.get(this.state.currentRecord, 'SellerProcessCost.value') ){
            formData['CustomData'] = _.extend(formData['CustomDataToUpdate'], {
                SellerProcessCost: _.get(this.state.currentRecord, 'SellerProcessCost.value'),
                ProductProcessCost:'unset'
            })
        }else  if( _.get(this.originalProductData, 'CustomData.SellerProcessCost') ){
            formData['CustomData'] = _.extend(formData['CustomDataToUpdate'], {
                SellerProcessCost:'unset',
            })
        }else  if( _.get(this.originalProductData, 'CustomData.ProductProcessCost') ){
            formData['CustomData'] = _.extend(formData['CustomDataToUpdate'], {
                ProductProcessCost:'unset',
            })
        }
        if (isNaN(formData['Payout'])) {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, specify valid Payout value'
            });
            return;

        }
        if (dataNotValid) {
            return false;
        }
        return formData
    }

    render() {
        const isShopifyListingPriceEnabled = this.state.isShopifyListingPriceEnabled
         if (!this.state.currentRecord._id) {
            return null;
        }
        return (

            <div>
                <h4 className="left0">
                    Edit product
                </h4>


                <div>
                    <Form onSubmit={this.state.newRecord ? this.addRecord : this.editRecord}>
                        <FormGroup>
                            <ControlLabel>Title</ControlLabel>
                            <FormControl type="text"
                                         onChange={(e) => {
                                             this.setState({currentRecord:{
                                                 ...this.state.currentRecord,
                                                 'ProductName': e.target.value}});
                                         }}
                                         defaultValue={this.state.currentRecord.ProductName} />

                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Description</ControlLabel>
                            <FormControl type="text"
                                         onChange={(e) => {
                                             this.setState({currentRecord:{
                                                 ...this.state.currentRecord,
                                                 'Description': e.target.value}});
                                         }}
                                         defaultValue={this.state.currentRecord.Description} />
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Base Price</ControlLabel>
                            <FormControl readOnly={isShopifyListingPriceEnabled} type="text"
                                         onChange={(e) => {
                                             this.setState({currentRecord:{
                                                 ...this.state.currentRecord,
                                                 'Price': e.target.value}});
                                         }}
                                         defaultValue={this.state.currentRecord.Price} />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Shopify Listing Price</ControlLabel>
                            <FormControl 
                                type="text"
                                readOnly={!isShopifyListingPriceEnabled}
                                onChange={(e) => {
                                    const shopifyListingPrice = e.target.value
                                    this.setState({currentRecord:{
                                        ...this.state.currentRecord,
                                        'ShopifyListingPrice': shopifyListingPrice}});
                                }}                            
                                value={_.get(this.state.currentRecord,  'ShopifyListingPrice', '')} />
                        </FormGroup>


                        <FormGroup>
                            <ControlLabel>Age groups</ControlLabel>
                            <Select
                                tabIndex="0"
                                placeholder="Age group"
                                clearable={false}
                                multi
                                options={getAllowedAgeGroups()}
                                onChange={ (selectedOptions)=> {
                                    var dataToUpdate = {
                                        ...this.state.currentRecord,
                                        'ProductAgeRange': selectedOptions
                                    }
                                    dataToUpdate.ProductTags = _.reject(dataToUpdate.ProductTags, function (tag) {
                                        return _.includes(tag.value, 'Age Group_')
                                    })
                                    dataToUpdate.ProductTags = _.concat(dataToUpdate.ProductTags,_.map(dataToUpdate.ProductAgeRange, ageRange=>{
                                        return  {value: 'Age Group_' + ageRange.value, label: 'Age Group_' + ageRange.value}
                                    }))
                                    this.setState({
                                        currentRecord:dataToUpdate
                                    })
                                }}
                                value={this.state.currentRecord.ProductAgeRange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Tags</ControlLabel>
                            <Select
                                tabIndex="0"
                                searchable ={true}
                                multi
                                selectedOptions
                                clearable={false}
                                placeholder="Product Tags"
                                //options={this.state.focusAreasOptionsList}
                                onChange={ (selectedOptions)=> {
                                    var dataToUpdate = {
                                        ...this.state.currentRecord,
                                        'ProductTags': selectedOptions
                                    }
                                    var conditionTagIndex = _.findIndex(dataToUpdate.ProductTags, function (tag) {
                                        return _.includes(tag.value, 'Condition_')
                                    })
                                    if (conditionTagIndex == -1) {
                                        dataToUpdate.Condition = ''
                                    }
                                    this.setState({
                                        currentRecord:dataToUpdate
                                    })

                                }}
                                value={this.state.currentRecord.ProductTags}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Status</ControlLabel>
                            <Select
                                clearable={false}
                                options={config.productStatusMap }
                                onChange={(option) => {
                                    if (option.value) {
                                        this.setState({
                                            currentRecord: {
                                                ...this.state.currentRecord,
                                                'Status': option.value
                                            }
                                        })
                                    }
                                }}
                                value={this.state.currentRecord.Status}
                            />

                        </FormGroup>


                        <FormGroup>
                            <ControlLabel>Condition</ControlLabel>
                            <Select
                                clearable={false}
                                options={_.map(config.productConditions, (item)=>{
                                    return {value:item, label:item}
                                })}
                                onChange={(option) => {
                                    if (option.value) {
                                        var dataToUpdate = {
                                            ...this.state.currentRecord,
                                            'Condition': option.value
                                        }
                                        var conditionTagIndex = _.findIndex(dataToUpdate.ProductTags, function (tag) {
                                            return _.includes(tag.value, 'Condition_')
                                        })
                                        if (conditionTagIndex !== -1) {
                                            _.pullAt(dataToUpdate.ProductTags,conditionTagIndex)
                                        }
                                        dataToUpdate.ProductTags.push({value:'Condition_' + option.value, label:'Condition_' + option.value})
                                        this.setState({
                                            currentRecord:dataToUpdate
                                        })
                                    }
                                }}

                                value={this.state.currentRecord.Condition}
                            />

                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Seller</ControlLabel>
                            <Select
                                clearable={false}
                                options={this.allSellersOptionsList}
                                onChange={(option) => {
                                    console.log('option', option  );
                                    if (option.value) {
                                        this.setState({
                                            currentRecord: {
                                                ...this.state.currentRecord,
                                                'SellerID': option.value
                                            }
                                        })
                                    }
                                }}
                                value={this.state.currentRecord.SellerID}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Payout (%)</ControlLabel>
                            <FormControl type="text"
                                         value={_.get(this.state.currentRecord,  'Payout', '')}
                                         onChange={(e) => {
                                             this.setState({currentRecord:{
                                                 ...this.state.currentRecord,
                                                 'Payout': e.target.value}});
                                         }} />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Location</ControlLabel>
                            <Select
                                clearable={false}
                                options={_.map(config.warehouseData, function (item, key) {
                                    return {value:key, label:_.startCase(key)}
                                })}
                                value={ _.get(this.state.currentRecord.Markets, '0.MarketName')}
                                onChange={(option) => {
                                    if (option.value) {
                                        this.setState({
                                            currentRecord: {
                                                ...this.state.currentRecord,
                                                'Markets':[{MarketName: option.value}],
                                            }
                                        })
                                    }
                                }}      />

                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Original Url</ControlLabel>
                            <FormControl type="text"
                                         value={_.get(this.state.currentRecord,  'OriginalUrl', '')}
                                         onChange={(e) => {
                                             this.setState({currentRecord:{
                                                 ...this.state.currentRecord,
                                                 'OriginalUrl': e.target.value}});
                                         }} />
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Original Description</ControlLabel>
                            <FormControl type="text"
                                         value={_.get(this.state.currentRecord,  'OriginalDescription', '')}
                                         onChange={(e) => {
                                             this.setState({currentRecord:{
                                                 ...this.state.currentRecord,
                                                 'OriginalDescription': e.target.value}});
                                         }} />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Original Price</ControlLabel>
                            <FormControl type="text"
                                         value={_.get(this.state.currentRecord,  'OriginalPrice', '')}
                                         onChange={(e) => {
                                             this.setState({currentRecord:{
                                                 ...this.state.currentRecord,
                                                 'OriginalPrice': e.target.value}});
                                         }} />
                        </FormGroup>

                        {_.get(this.originalProductData, 'SellerID.PartnerData.ProcessCostOptions', []).length > 0 &&
                        <FormGroup>
                            <ControlLabel>Process Cost</ControlLabel>
                            <Row>
                                <Col md={10} sm={10} xs={12} className="bot10">
                                    <Select
                                        tabIndex="0"
                                        searchable={false}
                                        selectedOptions
                                        clearable={false}
                                        placeholder=""

                                        options={_.map(_.get(this.originalProductData, 'SellerID.PartnerData.ProcessCostOptions', []), item=>{
                                        return {value:item.Slug,   label:item.Label + ' - ' + formatNumbers.formatMoney(item.Amount) }
                                        })
                                        }
                                        onChange={(selectedOption) => {
                                            console.log('selectedOption', selectedOption  );
                                            this.setState({
                                                currentRecord: {
                                                    ...this.state.currentRecord,
                                                    'SellerProcessCost':selectedOption,
                                                    displayOverrideProcessingCost:false,
                                                    ProductProcessCost:''
                                                }
                                            })
                                        }  }
                                        value={_.get(this.state.currentRecord,'SellerProcessCost','') }
                                    />
                                </Col>
                                <Col md={2}  sm={2} xs={12} className="bot10">
                                    <Button className=" btn btn-primary " type="button"
                                            onClick={() =>  {
                                                this.setState({
                                                    currentRecord: {
                                                        ...this.state.currentRecord,
                                                        SellerProcessCost:{},
                                                        'displayOverrideProcessingCost':true
                                                    }
                                                })
                                            }
                                            }>
                                        Override
                                    </Button>
                                </Col>
                            </Row>
                            {_.get(this.state.currentRecord, 'displayOverrideProcessingCost') &&
                            <div>
                                <ControlLabel>Process cost to use</ControlLabel>
                                <FormControl type="number" min="0" max="100"
                                             value={_.get(this.state.currentRecord,  'ProductProcessCost', '')}
                                             onChange={(e) => {
                                                 this.setState({currentRecord:{
                                                     ...this.state.currentRecord,
                                                     SellerProcessCost:{},
                                                     'ProductProcessCost': e.target.value}});
                                             }} />
                            </div>
                            }
                        </FormGroup>
                        }

                        <FormGroup>
                            <Button className="btn-primary" type="submit">
                                Save
                            </Button>
                        </FormGroup>
                    </Form>
                    <FormGroup>
                        <ControlLabel>Images</ControlLabel>
                        <AdminProductImageEdit currentProduct={this.originalProductData}  {...this.props}   />
                        <div className="clearfix"></div>
                    </FormGroup>
                </div>

            </div >
        );
    }
}

function mapStateToProps(state, props) {
    return {
        // seller: getSeller(state, props.params.id),
        focusAreas: state.focusAreas,
        allSellersList: state.allSellersList,
        // product: getProduct(state, props.params.product_id),
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateRecord,
        makeRequest,
        reorderImages,
        displayMessage
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminProductEdit);